import React from 'react';
import { Card } from '../ui/Card';
import { MOCK_WATCHED_VEHICLES } from '../../utils/multiSiteData';
import { AlertCircle, MapPin } from 'lucide-react';
import { Badge } from '../ui/Badge';
import { format } from 'date-fns';
export function VehicleWatchlist() {
  return <Card className="h-full flex flex-col" noPadding data-id="element-269">
      <div className="p-4 border-b border-gray-800" data-id="element-270">
        <h3 className="font-semibold text-white" data-id="element-271">Enterprise Watchlist</h3>
      </div>
      <div className="overflow-auto" data-id="element-272">
        <table className="w-full text-sm text-left" data-id="element-273">
          <thead className="text-xs text-gray-500 bg-gray-900/50 uppercase" data-id="element-274">
            <tr data-id="element-275">
              <th className="px-4 py-3 font-medium" data-id="element-276">Vehicle</th>
              <th className="px-4 py-3 font-medium" data-id="element-277">Risk</th>
              <th className="px-4 py-3 font-medium" data-id="element-278">Sites Visited</th>
              <th className="px-4 py-3 font-medium" data-id="element-279">Status</th>
              <th className="px-4 py-3 font-medium text-right" data-id="element-280">Warnings</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800" data-id="element-281">
            {MOCK_WATCHED_VEHICLES.map(vehicle => <tr key={vehicle.id} className="hover:bg-gray-800/30 transition-colors" data-id="element-282">
                <td className="px-4 py-3 font-mono text-white" data-id="element-283">
                  {vehicle.plate}
                </td>
                <td className="px-4 py-3" data-id="element-284">
                  <Badge variant={vehicle.riskLevel === 'high' ? 'danger' : vehicle.riskLevel === 'medium' ? 'warning' : 'neutral'} data-id="element-285">
                    {vehicle.riskLevel.toUpperCase()}
                  </Badge>
                </td>
                <td className="px-4 py-3 text-gray-400" data-id="element-286">
                  <div className="flex flex-wrap gap-1" data-id="element-287">
                    {vehicle.sitesVisited.map(site => <span key={site} className="inline-block px-1.5 py-0.5 bg-gray-800 rounded text-[10px] border border-gray-700" data-id="element-288">
                        {site}
                      </span>)}
                  </div>
                </td>
                <td className="px-4 py-3" data-id="element-289">
                  {vehicle.currentStatus === 'inside' ? <div className="flex items-center text-xs text-emerald-500" data-id="element-290">
                      <MapPin className="h-3 w-3 mr-1" data-id="element-291" />
                      {vehicle.currentSite}
                    </div> : <span className="text-xs text-gray-500" data-id="element-292">Outside</span>}
                </td>
                <td className="px-4 py-3 text-right font-medium text-gray-300" data-id="element-293">
                  {vehicle.warningsIssued}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
}